import { Typography } from 'components/generic/typography';
import styled from 'styled-components';
import { FontLineHeightNormal } from 'autogen/design-tokens/tokens';
import { ArticleHeaderFromContextProps } from '../shared/types';

const StyledTitle = styled(Typography.Title)`
    display: block;
    line-height: ${FontLineHeightNormal};
`;

export default function Teaser({ teaser, ...restProps }: { teaser: ArticleHeaderFromContextProps['teaser'] }) {
    return (
        <StyledTitle size="S" {...restProps}>
            {teaser}
        </StyledTitle>
    );
}
